<template>
    <div v-loading="loading" class="order-infoTab-section">
        <div class="order-hd" v-if="Acs('/order/create') && isEdit">
            <a href="javascript:;" @click="addOrder">+新增订单</a>
        </div>
        <el-table
            class="el-tab--padding"
            :data="orders"
            style="width: 100%">
            <el-table-column type="expand">
                <template slot-scope="props">
                    <el-form label-position="left" inline class="demo-table-expand">
                        <el-form-item label="订单ID"><span>{{props.row.id}}</span></el-form-item>
                        <el-form-item label="订单编号"><span>{{props.row.no}}</span></el-form-item>
                        <el-form-item label="客户名称：">
                            <span>{{ props.row.customer_name }}</span>
                        </el-form-item>
                        <el-form-item label="客户联系人：">
                            <span>{{ props.row.contact_name }}</span>
                        </el-form-item>
                        <el-form-item label="成交产品：">
                            <div v-for="value in props.row.products" :key="value.id">
                                    <el-tag  v-if="value.is_active">{{ value.product_name }}</el-tag>
                                    <el-tag type="info" v-else >{{ value.product_name }}</el-tag>
                            </div>
                        </el-form-item>
                        <el-form-item label="合同金额：">
                            <span>{{ props.row.finance ? props.row.finance.total_amount : '' }}</span>
                        </el-form-item>
                        <el-form-item label="业绩金额：">
                            <span>{{ props.row.finance ? props.row.finance.total_performance_amount : '' }}</span>
                        </el-form-item>
                        <el-form-item label="续费金额：">
                            <span>{{ props.row.finance ? props.row.finance.renew_amount : '' }}</span>
                        </el-form-item>
                        <el-form-item label="创建时间：">
                            <span>{{ props.row.created_at }}</span>
                        </el-form-item>
                        <el-form-item label="业务员：">
                            <span v-for="salesman in props.row.user" :key="salesman.user_id" v-if="salesman.is_cooperator == 0" >{{ salesman.name }}</span>
                        </el-form-item>
                        <el-form-item label="协作人：">
                            <span v-for="salesman in props.row.user" :key="salesman.user_id" v-if="salesman.is_cooperator == 1" >{{ salesman.name }}<span v-if="props.row.user.length != 2" >、</span></span>
                        </el-form-item>
                        <el-form-item label="合同附件：" v-if="props.row.contracts">
                            <span v-for="(contract,index) in props.row.contracts" :key="index">
                                <span><a v-bind:href="contract.url" style="color:red">附件{{index + 1}}</a></span>
                            </span>
                            <a>{{ props.row.desc }}</a>
                        </el-form-item>
                    </el-form>
                </template>
            </el-table-column>

            <el-table-column
                    label="类型"
                    prop="type_memo"
                    width="120">
            </el-table-column>
            <el-table-column label="成交产品" prop="product_memo">
                <template slot-scope="scope">
                    <div v-for="value in scope.row.products" >
                        <el-button size="mini" type="primary"  v-if="value.is_active" @click="to_product_config(value)">{{ value.product_name }}</el-button>
                        <el-button size="mini" type="info" v-else >{{ value.product_name }}</el-button>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="合同金额">
                <template slot-scope="scope">
                    <slot v-if="scope.row.finance">
                        <div>{{scope.row.finance.total_amount}}</div>
                    </slot>
                </template>
            </el-table-column>
            <el-table-column
                    label="业绩金额"
                    prop="performance_total_amount">
            </el-table-column>
            <el-table-column
                    label="合同时间"
                    prop="created_at">
                <template slot-scope="scope">
                    <slot v-if="scope.row.finance && scope.row.finance.contract_time.length>0 ">
                        <div>{{scope.row.finance.contract_time[0]}}~{{scope.row.finance.contract_time[1]}}</div>
                    </slot>
                </template>
            </el-table-column>
            <el-table-column label="审核状态" >
                <template slot-scope="scope">
                    <el-tooltip v-if="scope.row.finance_audit==1 && scope.row.contract_audit == 1 "  effect="dark"   placement="right-start">
                        <span slot="content"><span v-html="showContent(scope.row)"></span></span>
                        <span style="color: #67C23A">审核通过</span>
                    </el-tooltip>
                    <el-tooltip v-else-if="scope.row.finance_audit==0 && (scope.row.contract_audit == 0 || scope.row.contract_audit == 3) "  effect="dark"  :content="showContent(scope.row)" placement="right-start">
                        <span slot="content"><span v-html="showContent(scope.row)"></span></span>
                        <span style="color: #F56C6C">不通过</span>
                    </el-tooltip>
                    <span v-else-if="scope.row.type==1 && scope.row.finance_audit==1 " style="color: #67C23A">审核通过</span>
                    <el-tooltip v-else  effect="dark"   placement="right-start">
                        <span slot="content"><span v-html="showContent(scope.row)"></span></span>
                        <span style="color: #E6A23C">待审核</span>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column width="200px" label="操作">
                <template slot-scope="scope">
                    <el-button @click="handleView(scope.row)" type="text" size="small">查看</el-button>
                    <!--<el-button @click="handleUpdate(scope.row)" v-if="showEditButton(scope.row)" type="text" size="small">编辑</el-button>-->
                    <el-button v-if="scope.row.type!=1 && scope.row.business_audit ==1 && !scope.row.close_audit && isEdit" @click="renew(scope.row)" type="text" size="small">续约</el-button>
                    <el-button v-if="(isEdit && Acs('/order/trial-order-close') && scope.row.type==1) || (Acs('/order/close') && scope.row.type != 1 && isEdit)" @click="handleCloseOrder(scope.row)"  type="text" size="small">关闭</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!--关闭订单弹窗-->
        <el-dialog title="关闭订单" :visible="dialogCloseOrder" :before-close="close">
            <close-form :order="closeOrder" @closeDialog="closeDialog"></close-form>
        </el-dialog>
        <el-row v-if="linkPage">
            <pagination :linkPage="linkPage" :enableEvent="true" @change="watchPageChange"></pagination>
        </el-row>
    </div>

</template>

<script>
    import OrderService from "~/services/order";
    import Pagination from "~/widgets/Pagination.vue";
    import params from "~/config/params";
    import CloseForm from "~/views/order/closeForm.vue";

    export default {
        // name: "CustomerOrders",
        data() {
            return {
                orders: [],
                loading: true,
                // 分页信息
                linkPage: null,
                customer_name: "",
                dialogCloseOrder:false,
                closeOrder:{}
            }
        },
        components: {
            Pagination,
            CloseForm
        },
        props: {
            customerId: {
                type: Number,
                default: 0,
                required: true
            },
            isEdit: {
                type: Boolean,
                default: false,
            },
            customerName: ""
        },
        watch: {
            customerId: function (value, original) {
                this.getOrders({customer_id: value});
            },
        },
        created: function () {
            if (this.orders.length < 1 && this.customerId > 0) {
                this.getOrders({customer_id: this.customerId});
            }
        },
        methods: {
            showEditButton(item) {
                if(item.type==params.TYPE_TRY_OUT) return false;
                if (!this.Acs('/order/edit'))return false;
                if(item.close_audit) return false;
                if(!item.finance) return true;
                if(item.contracts.length==0) return true;
                return false;
            },
            //关闭dialog弹窗
            close() {
                this.dialogCloseOrder = false;
            },
            showContent(row){
               return OrderService.showCheckInfo(row);
            },
            renew(obj){
                let path = "/order/renew?id="+obj.id;
                this.$router.push({
                    path: path,
                    query: {
                        referer: this.$route.path
                    }
                });
            },
            /**
             * 监听分页改变时间
             * @param pageParams
             */
            watchPageChange(pageParams) {
                this.getOrders({
                    customer_id: this.customerId,
                    page: pageParams['page'],
                    perPage: pageParams['perPage']
                });
            },

            getOrders(params) {
                OrderService.commonList(params).then(res => {
                    if (res && res.data) {
                        this.orders = res.data;
                        if (res._meta) {
                            this.linkPage = res._meta;
                        }
                        if(this.orders.length) {
                            this.orders.forEach(order => {
                                if (order.order_sensitive_masked) {
                                    order.performance_total_amount = '******';
                                    return;
                                }
                                order.performance_total_amount = _.reduce(order.user, (memo, item) => {
                                    return memo + (Number(item.pfm_amount) || 0)
                                }, 0);
                            });
                        }
                        this.loading = false;
                    }
                }).catch(err => {
                    this.loading = false;
                    console.error(err);
                })
            },
            //关闭dialog订单
            handleCloseOrder(row) {
                this.closeOrder = Object.assign({}, row);
                this.close_reason = '';
                this.dialogCloseOrder = true;
            },
            closeDialog(submit){
                if(typeof submit =='boolean'){
                    this.orders = this.orders.filter(item=>{
                        return item.id != this.closeOrder.id;
                    })
                }
                this.dialogCloseOrder = false;
            },
            showCloseButton(item) {
                if (this.Acs('/order/close') && !item.close_audit
                    && (item.business_audit == 1
                        || item.finance_audit == 1
                        || item.contract_audit == 1
                        || item.business_audit==3 || item.business_audit==0 )) {
                    return true;
                }
                return false;
            },
            // 查看订单
            handleView(order) {
                let routeData = this.$router.resolve({
                    path: "/order/view",
                    query: { id: order.id },
                });
                window.open(routeData.href, '_blank');
                // this.$router.push({
                //     path: "/order/view",
                //     query: {
                //         id: order.id
                //     }
                // });
            },
            // 编辑订单
            handleUpdate(customer) {
                this.$router.push({
                    path: "/order/edit",
                    query: {
                        id: customer.id
                    }
                });
            },
            // 新增订单
            addOrder() {
                let routeData = this.$router.resolve({
                    path: "/order/create",
                    query: { name: this.customerName, customer_id: this.customerId, onlyShow: true },
                });
                window.open(routeData.href, '_blank');
            },
            to_product_config(raw){
                if(!raw.is_active) return false
                this.$router.push({
                    path: "/customers/view",
                    query: {
                        id: this.$route.query['id'],
                        tab:'product',
                        code:raw.code
                    }
                });
            }
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .demo-table-expand {
        font-size: 0;
    }

    .demo-table-expand label {
        width: 96px;
        color: #99a9bf;
    }

    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    }

    .el-form-item__content > a {
        color: #1890ff;
    }

    .el-form-item__content > a:hover {
        color: #4ba9ff;
    }
</style>





// WEBPACK FOOTER //
// src/views/customer/Orders.vue